<template>
  <div class="user-management-main">
    <Menus :menu="menuItems" icon="https://dsmlib.logistics.systems/Icons/UserColoredIcon.png" @menuClicked="menuClicked" />
    <div class="right-container">
      <TableBox :tableData="userLists" title="User" :maxSelection="1" :selectedRow.sync="selectedUser" @rowSelected="userSelected" />
    </div>

    <PopupEntry :show.sync="showPopupEntry" v-if="showPopupEntry" :createdBy="createdBy" :updatedBy="updatedBy" :title="popupTitle"
      @save="saveClicked" :requiredError="requiredMessages" :successMessages="successMessages" :errorMessages="errorMessages"
      @requiredClicked="popupRequiredClicked" :viewMode="viewMode" :cancelButton="popupTitle[0] == 'V' ? 'Close' : 'Cancel'">
      <div class="popup-content">
        <div class="popup-details">
          <Input placeholder="User Email" :inputValue.sync="userEmail" :isRequired="true" :errorMessage.sync="userEmailError" ref="userEmail"
            :isDisabled="popupTitle[0] == 'V'" />
          <Input placeholder="User ID (More than 5 characters)" :inputValue.sync="userID" :isRequired="true" :errorMessage.sync="userIDError" ref="userID"
            :isDisabled="popupTitle[0] == 'E' || popupTitle[0] == 'V'"  validator="text,20,,alphanumeric,all"/>
          <Input placeholder="User Name" :inputValue.sync="userName" :isRequired="true" :errorMessage.sync="userNameError" ref="userName"
            :isDisabled="popupTitle[0] == 'V'" validator="text,35,,alphanumeric,all" />
          <Input placeholder="Section" :inputValue.sync="section" :isDisabled="popupTitle[0] == 'V'" validator="text,6,uppercase,alphanumeric,all" />
          <Input placeholder="Indicator" :inputValue.sync="indicator" :isDisabled="popupTitle[0] == 'V'" validator="text,1,uppercase,alphanumeric,all" />
          <Input placeholder="Mobile #" :inputValue.sync="mobileNo" :isDisabled="popupTitle[0] == 'V'" validator="text,20,,alphanumeric,all" />
          <InputQuery placeholder="Team" :items="teamList" itemKey="Team" descKey="Description" :selectedObject.sync="selectedTeam" :isDisabled="popupTitle[0] == 'V'" />
          <InputQuery placeholder="Employee" :items="employeeList" itemKey="EmployeeID" descKey="Employee Name" :selectedObject.sync="selectedEmployee"
            :isDisabled="popupTitle[0] == 'V'" />
          <InputQuery placeholder="Role ID" :items="roleList" itemKey="RoleID" descKey="Description" :selectedObject.sync="selectedRole" :isRequired="true"
            :errorMessage.sync="selectedRoleError" ref="role" :isDisabled="popupTitle[0] == 'V'" />
          <InputQuery placeholder="Branch" :items="branchList" itemKey="Branch Code" descKey="Branch Name" :selectedObject.sync="selectedBranch" 
            :isDisabled="popupTitle[0] == 'V'" />
        </div>
        <div class="popup-details">
          <div>Profile Image</div>
          <div class="image-container">
            <div v-if="!profileImage" class="input-text">{{ popupTitle[0] == 'V' ? 'No Profile Image available' : 'Drag or click to select your Profile Image' }}</div>
            <input type="file" title="Profile Image" @change="inputFileChanged" @dragenter="inputDragEnter" @dragleave="inputDragLeave"
              :disabled="popupTitle[0] == 'V'">

            <div class="hovering" v-if="profileImageHover && popupTitle[0] != 'V'">Drop your Profile Image</div>
            <div class="image" v-if="profileImage">
              <div class="close" v-if="popupTitle[0] != 'V'" @click="deleteImageClicked('profileImage', $event)">❌</div>
              <img :src="profileImage" alt="">
            </div>
          </div>
          <div>QR Code</div>
          <div class="image-container">
            <div v-if="!qrCode" class="input-text">{{ popupTitle[0] == 'V' ? 'No QR Code available' : 'Drag or click to select your QR Code' }}</div>
            <input type="file" title="QR Code" @change="inputFileChanged" @dragenter="inputDragEnter" @dragleave="inputDragLeave"
              :disabled="popupTitle[0] == 'V'">

            <div class="hovering" v-if="qrCodeHover && popupTitle[0] != 'V'">Drop your QR Code</div>
            <div class="image" v-if="qrCode">
              <div class="close" v-if="popupTitle[0] != 'V'" @click="deleteImageClicked('qrCode', $event)">❌</div>
              <img :src="qrCode" alt="">
            </div>
          </div>
        </div>
      </div>
    </PopupEntry>

    <PopupV2 :show="popupShow" :type="popupType" :icon="popupIcon" :title="popupTitle" :content="popupContent" @buttonClicked="popupV2ButtonClicked"
      :buttons="popupButtons" />
    <Loader :isVisible.sync="loading" :loadingText="loadingText" />
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  data: function() {
    return {
      loading: false,
      loadingText: 'Loading',

      menuItems: [
        { title: 'New User', icon: 'https://img.icons8.com/small/96/000000/add-user-male.png' },
        { title: 'Edit User', icon: 'https://img.icons8.com/small/96/000000/edit-user-male.png' },
        { title: 'Delete User', icon: 'https://img.icons8.com/small/96/000000/remove-user-male.png' },
        { title: 'View User', icon: 'https://img.icons8.com/small/96/000000/find-user-male.png' },
        { title: 'Reset Password', icon: 'https://img.icons8.com/small/96/000000/change-user-male.png' },
        { title: 'Logout User', icon: 'https://dsmlib.logistics.systems/Icons/Logout.png' },
      ],

      userLists: [],
      selectedUser: [],

      userHashes: [],

      showPopupEntry: false,
      popupTitle: '',
      viewMode: false,
      successMessages: [],
      errorMessages: [],
      requiredMessages: [],

      createdBy: '',
      updatedBy: '',

      userEmail: '',
      olduserEmail: '',
      userID: '',
      userName: '',
      section: '',
      indicator: '',
      mobileNo: '',

      teamList: [],
      selectedTeam: null,
      employeeList: [],
      selectedEmployee: null,
      roleList: [],
      selectedRole: null,
      branchList: [],
      selectedBranch: null,

      profileImageHover: false,
      qrCodeHover: false,

      profileImage: '',
      qrCode: '',
      profileImageFile: null,
      qrCodeFile: null,
      haveProfileImage: false,
      removeProfileImage: false,
      haveQRCodeFile: false,
      removeQRCodeFile: false,

      userEmailError: '',
      userIDError: '',
      userNameError: '',
      selectedRoleError: '',

      popupShow: false,
      popupType: '',
      popupIcon: '',
      popupTitle: '',
      popupContent: '',
      popupButtons: [],
    }
  },
  props: {
  },
  methods: {
    menuClicked: async function(menu) {
      switch (menu['title']) {
        case 'New User':

          this.showPopupEntry = true;
          this.viewMode = false;
          this.popupTitle = menu['title'];
          this.clearUserForm();
          break;
        case 'Edit User':
          if (this.selectedUser.length == 0) {
            this.popupShow = true;
            this.popupType = 'error';
            this.popupTitle = 'No user selected';
            this.popupContent = 'Please select a user to edit.';
          } else {
            this.popupTitle = menu['title'];
            this.showPopupEntry = true;
            this.viewMode = false;
            this.clearUserForm();
            this.populateUser(this.selectedUser[0]);
          }
          break;
        case 'Delete User':

          if (this.selectedUser.length == 0) {
            this.popupShow = true;
            this.popupType = 'error';
            this.popupTitle = 'No user selected';
            this.popupContent = 'Please select a user to delete.';
          } else {
            this.popupShow = true;
            this.popupType = 'warning';
            this.popupTitle = 'Deleting User';
            this.popupContent = `Are you sure you want to delete ${this.selectedUser[0]['UserID']}? This cannot be undone.`;
            this.popupButtons = [
              { text: 'Delete', textColor: 'white', color: 'red' },
              { text: 'Cancel', textColor: 'black', color: 'lightgray' }
            ];
            this.clearUserForm();
            this.populateUser(this.selectedUser[0]);
          }
          break;
        case 'View User':
          if (this.selectedUser.length == 0) {
            this.popupShow = true;
            this.popupType = 'error';
            this.popupTitle = 'No user selected';
            this.popupContent = 'Please select a user to view.';
          } else {
            this.popupTitle = menu['title'];
            this.showPopupEntry = true;
            this.viewMode = true;
            this.clearUserForm();
            this.populateUser(this.selectedUser[0]);
          }
          break;
        case 'Reset Password':
          if (this.selectedUser.length == 0) {
            this.popupShow = true;
            this.popupType = 'error';
            this.popupTitle = 'No user selected';
            this.popupContent = 'Please select a user to reset the password.';
          } else {
            this.popupShow = true;
            this.popupType = 'warning';
            this.popupTitle = 'Reset Password';
            this.popupContent = `Are you sure you want to reset password for ${this.selectedUser[0]['UserID']}? Once reset, the password is the same as user id.`;
            this.popupButtons = [
              { text: 'Reset', textColor: 'white', color: 'red' },
              { text: 'Cancel', textColor: 'black', color: 'lightgray' }
            ];
          }
          break;
        default:
          let hasCount = menu['title'].match(/(\()(.*?)(\))/g);
          if (!hasCount) {
            this.$showAlert('error', 'No User Selected', 'Please select a user to logout');
          } else {
            let count = Number(hasCount[0].split('(').join('').split(')').join(''));

            if (count == 0) {
              this.$showAlert('error', 'Unable to Logout', `<b>${this.selectedUser[0]['UserID']}</b> is not currently logged in.`)
            } else {
              let logout = await this.$showAlert('warning', 'Logout User', `Currently <b>${this.selectedUser[0]['UserID']}</b> is logged across <b>${count}</b> different devices.<br><br>Are you sure you want to logout this user?<br>If you logout, this user needs to login again in all their devices.`, [
                { text: 'Logout', color: 'red', textColor: 'white' },
                { text: 'Cancel', color: 'gray', textColor: 'white' },
              ]);
  
              if (logout == 'Logout') {
                this.$fullscreenLoading('Logging Out');
                for (let h of this.userHashes) {
                  await this.$apiCallV2(`/Login/RemoveLoginDetails?key=${h}`);
                }
                this.$fullscreenLoading();

                this.userSelected(this.selectedUser[0], true);
              }
            }
          }
          break;
      }
    },
    getUsers: async function() {
      this.loading = true;

      this.loadingText = 'Getting Users';
      let userData = await this.$apiCallV2(`/UserManagement/GetListMaster?master=user`);

      this.userLists = [];
      this.$nextTick(() => this.userLists = userData);
      this.selectedUser = [];

      this.loading = false;
    },

    populateUser: async function(details) {
      this.createdBy = `${details['Created by']} ${details['Created on']}`;
      this.updatedBy = details['Updated by'] ? `${details['Updated by']} ${details['Updated on']}` : '';

      this.userEmail = details['User Email'] ? details['User Email'].trim() : '';
      this.olduserEmail = details['User Email'] ? details['User Email'].trim() : '';
      this.userID = details['UserID'] ? details['UserID'].trim() : '';
      this.userName = details['User Name'] ? details['User Name'].trim() : '';
      this.section = details['Section'] ? details['Section'].trim() : '';
      this.indicator = details['Indicator'] ? details['Indicator'].trim() : '';
      this.mobileNo = details['Mobile #'] ? details['Mobile #'].trim() : '';

      let team = details['Team'] ? details['Team'].trim() : '';
      let employee = details['Employee Code'] ? details['Employee Code'].trim() : '';
      let role = details['Role ID'] ? details['Role ID'].trim() : '';
      let branch = details['Branch'] ? details['Branch'].trim() : '';
      
      this.selectedTeam = team ? this.teamList.find(t => t['Team'] == team) : null;
      this.selectedEmployee = employee ? this.employeeList.find(e => e['EmployeeID'] == employee) : null;
      this.selectedRole = role ? this.roleList.find(t => t['RoleID'].toLowerCase().trim() == role.toLowerCase().trim()) : null;
      this.selectedBranch = branch ? this.branchList.find(t => t['Branch Code'] == branch) : null;

      this.loading = true;

      this.loadingText = 'Getting Profile Image and QR Code';
      let savedImages = await this.$apiCallV2(`/UserManagement/GetProfileImage?userid=${this.userID}&brcode=${this.selectedBranch ? this.selectedBranch['Branch Code'] : ''}`);
      if (savedImages[0]['ProfileImage']) {
        this.profileImage = `data:${savedImages[0]['ProfileImageFileExt']};base64,${savedImages[0]['ProfileImage']}`;
        this.haveProfileImage = true;
      }
      if (savedImages[0]['QRImage']) {
        this.qrCode = `data:${savedImages[0]['QRImageFileExt']};base64,${savedImages[0]['QRImage']}`;
        this.haveQRCodeFile = true;
      }

      this.loading = false;
    },

    clearUserForm: function(){
      this.createdBy = '';
      this.updatedBy = '';

      this.userEmail = '';
      this.olduserEmail = '';
      this.userID = '';
      this.userName = '';
      this.section = '';
      this.indicator = '';
      this.mobileNo = '';

      this.selectedTeam = null;
      this.selectedEmployee = null;
      this.selectedRole = null;
      this.selectedBranch = null;

      this.userEmailError = '';
      this.userIDError = '';
      this.userNameError = '';

      this.selectedRoleError = '';
      this.selectedBranchError = '';

      this.profileImage = '';
      this.profileImageFile = null;
      this.haveProfileImage = false;
      this.removeProfileImage = false;
      this.qrCode = '';
      this.qrCodeFile = null;
      this.haveQRCodeFile = false;
      this.removeQRCodeFile = false;

      this.successMessages = [];
      this.errorMessages = [];
      this.requiredMessages = [];

      //this.popupTitle = '';
      
    },

    inputFileChanged: async function(e) {
      let target = e.target.title;
      let file = Array.from(e.target.files)[0];
      if (!this.isImageFile(file)) {
        this.$showAlert("error", "File not support", "File not supported", [{ "text": "OK" }]);
        return;
      }
      switch (target) {
        case 'Profile Image':
          this.profileImageHover = false;
          this.profileImageFile = file;
          this.profileImage = `data:${file['type']};base64,${await this.$convertFile.toBase64(file)}`;
          this.removeProfileImage = false;
          break;
        case 'QR Code':
          this.qrCodeHover = false;
          this.qrCodeFile = file;
          this.qrCode = `data:${file['type']};base64,${await this.$convertFile.toBase64(file)}`;
          this.removeQRCodeFile = false;
          break;
      }
    },
    inputDragEnter: function(e) {
      let target = e.target.title;
      switch (target) {
        case 'Profile Image':
          this.profileImageHover = true;
          break;
        case 'QR Code':
          this.qrCodeHover = true;
          break;
      }
    },
    inputDragLeave: function(e) {
      let target = e.target.title;
      switch (target) {
        case 'Profile Image':
          this.profileImageHover = false;
          break;
        case 'QR Code':
          this.qrCodeHover = false;
          break;
      }
    },
    deleteImageClicked: function(image, e) {
      let parent = e.target.parentNode.parentNode;
      switch (image) {
        case 'profileImage':
          this.profileImage = '';
          this.profileImageFile = null;
          this.removeProfileImage = true;
          break;
        case 'qrCode':
          this.qrCode = '';
          this.qrCodeFile = null;
          this.removeQRCodeFile = true;
          break;
      }

      let input = parent.getElementsByTagName('input');
      input[0].value = '';
    },

     isImageFile: function (file) {
      const acceptedTypes = ["png", "jpg", "jpeg"];
      const filenameSplit = file["name"].split(".");
      const fileExtension = filenameSplit[filenameSplit.length - 1];
      return acceptedTypes.includes(fileExtension);
    },

    saveClicked: async function() {
      this.successMessages = [];
      this.errorMessages = [];
      this.requiredMessages = [];

      let error = false;
      if (!this.userEmail) {
        this.userEmailError = 'User Email is required!';
        this.requiredMessages.push({ Key: 'userEmail', Value: 'User Email is required!' });
        error = true;
      }
      if(this.userEmail && this.$validateEmail(this.userEmail) === false){
        this.userEmailError = 'Invalid Email format!';
        this.requiredMessages.push({ Key: 'userEmail', Value: 'Invalid Email format!' });
        error = true;
      }
      if (!this.userID) {
        this.userIDError = 'User ID is required!';
        this.requiredMessages.push({ Key: 'userID', Value: 'User ID is required!' });
        error = true;
      }
      if (this.userID.trim().length > 20) {
        this.userIDError = 'User ID cannot exceed 20 characters!';
        this.requiredMessages.push({ Key: 'userID', Value: 'User ID cannot exceed 20 characters!' });
        error = true;
      }
      if (!this.userName) {
        this.userNameError = 'User Name is required!';
        this.requiredMessages.push({ Key: 'userName', Value: 'User Name is required!' });
        error = true;
      }
      if (!this.selectedRole) {
        this.selectedRoleError = 'Role is required!';
        this.requiredMessages.push({ Key: 'role', Value: 'Role is required!' });
        error = true;
      }

      if (!error) {
        let dataToPost = {
          'UserEmail': this.userEmail,
          'OldUserEmail': this.olduserEmail,
          'UserID': this.userID,
          'UserName': this.userName,
          'Section': this.section,
          'Indicator': this.indicator,
          'MobileNo': this.mobileNo,
          'Team': this.selectedTeam ? this.selectedTeam['Team'] : '',
          'Staff_No': this.selectedEmployee ? this.selectedEmployee['EmployeeID'] : '',
          'RoleID': this.selectedRole ? this.selectedRole['RoleID'] : '',
          'BrCode': this.selectedBranch ? this.selectedBranch['Branch Code'] : '',
          'DeviceID': '124',
          'Action': this.popupTitle ? this.popupTitle[0] : 'D'
        };
        
        this.$fullscreenLoading('Saving User Details');
        let saveResult = await this.$apiCallV2('/UserManagement/SaveUserAccount', dataToPost);
        this.$fullscreenLoading();
        if (dataToPost['Action'] != 'D') { // For new or edit user
          if (saveResult[0]['Results'] == 0) { // Success save user details
            let success = true;

            if (this.profileImageFile || (this.removeProfileImage && this.haveProfileImage)) { // Save profile image if not empty
              let imgToPost = {
                'UserID': this.userID,
                'DeviceID': '124',
                'MobileNo': this.mobileNo,
                'Action': 'P',
                'ProfileImageFileExt': this.removeProfileImage ? '' : this.profileImageFile['type'],
                'ProfileImage': this.removeProfileImage ? '' : await this.$convertFile.toBase64(this.profileImageFile)
              };
              this.$fullscreenLoading ('Saving User Profile Image');
              let saveProfileImage = await this.$apiCallV2('/UserManagement/SaveUserAccount', imgToPost);
              this.$fullscreenLoading();
              if (saveProfileImage[0]['Results'] != 0) { // If error saving profile image
                success = false;
                this.errorMessages.push(saveProfileImage[0]['ErrMsg']);
              }
            }

            if (this.qrCodeFile || (this.removeQRCodeFile && this.haveQRCodeFile)) { // Save QR Code if not empty
              let imgToPost = {
                'UserID': this.userID,
                'DeviceID': '124',
                'MobileNo': this.mobileNo,
                'Action': 'Q',
                'QRImageFileExt': this.removeQRCodeFile ? '' : this.qrCodeFile['type'],
                'QRImage': this.removeQRCodeFile ? '' : await this.$convertFile.toBase64(this.qrCodeFile)
              };
              this.$fullscreenLoading ('Saving User QR Code');
              let saveQrCode = await this.$apiCallV2('/UserManagement/SaveUserAccount', imgToPost);
              this.$fullscreenLoading();
              if (saveQrCode[0]['Results'] != 0) { // If error saving QRCode
                success = false;
                this.errorMessages.push(saveQrCode[0]['ErrMsg']);
              }
            }

            if (success) {
              this.successMessages.push(`Successfully saved user - ${this.userName}`);
              this.viewMode = true;
              await this.getUsers();
              this.clearUserForm();
              let userProfileDetails = this.userLists.find( u => u['UserID'] === dataToPost.UserID);
              this.popupTitle = this.menuItems[3]['title'];
              this.populateUser(userProfileDetails);
              
            }
          } else { // Error save user details
            this.errorMessages.push(saveResult[0]['ErrMsg']);
          }
        } else { // For delete 

          if (saveResult[0]['Results'] == 0) { // Delete successfull
            this.popupShow = true;
            this.popupType = 'success';
            this.popupTitle = 'User Deleted';
            this.popupContent = `${this.selectedUser[0]['UserID']} has been successfully deleted!`;

            this.getUsers();
          } else { // Delete Error
            this.popupShow = true;
            this.popupType = 'error';
            this.popupTitle = 'User Not Deleted';
            this.popupContent = `There was an error occured while trying to delete ${this.selectedUser[0]['UserID']}. Please try again.`;
          }
        }
      } else {
        if (this.popupTitle.trim() == 'Deleting User') {
          this.popupShow = true;
          this.popupType = 'error';
          this.popupTitle = 'User Not Deleted';
          this.popupContent = 'UserID, User Email, User Name, Role ID, Branch is required to delete user. ';
        }
      }
    },
    popupRequiredClicked: function(e) {
      this.$refs[e].setFocus();
    },

    popupV2ButtonClicked: async function(e) {
      this.popupShow = false;
      this.popupButtons = [];

      if (e == 'Delete') {
        this.saveClicked();
      } else if (e == 'Reset') {
        this.loading = true;
        this.loadingText = 'Resetting password';
        let reset = await this.$apiCallV2('/UserManagement/ResetPassword', {
          "UserID": this.selectedUser[0]['UserID'],
          "DeviceID": "124",
          "UserPwd": "",
          "Action": 'R',
          "RoleID": this.selectedUser[0]['Role ID']
        });
        this.loading = false;
        
        this.popupShow = true;
        if (reset[0]['Results'] == 0) {
          this.popupType = 'success';
          this.popupTitle = 'Password Reset';
          this.popupContent = `Password for ${this.selectedUser[0]['UserID']} has been reset`;
        } else {
          this.popupType = 'error';
          this.popupTitle = 'Password not reset';
          this.popupContent = `There was an error occurred while trying to reset password for ${this.selectedUser[0]['UserID']}. Please try again.`;
        }
      }
    },

    userSelected: async function(data, selected) {
      let logoutUserButton = this.menuItems.find(m => m['title'].includes('Logout User'));
      if (!logoutUserButton) { return }

      if (selected) {
        this.userHashes = await this.$apiCallV2(`/UserManagement/CheckUserLogin?userid=${data['UserID']}`);
        logoutUserButton['title'] = `Logout User (${this.userHashes.length})`;
      } else {
        logoutUserButton['title'] = `Logout User`;
      }
    }
  },
  async mounted() {
    await this.getUsers();
    
    this.loading = true;

    this.loadingText = 'Getting Team';
    this.teamList = await this.$apiCallV2(`/UserManagement/GetListMaster?master=team`);
    
    this.loadingText = 'Getting Employee';
    this.employeeList = await this.$apiCallV2(`/UserManagement/GetListMaster?master=employee`);

    this.loadingText = 'Getting Roles';
    this.roleList = await this.$apiCallV2(`/UserManagement/GetListMaster?master=role`);

    this.loadingText = 'Getting Branches';
    this.branchList = await this.$apiCallV2(`/UserManagement/GetListMaster?master=branch`);

    this.loading = false;
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';
.user-management-main {
  padding: 10px 45px;
  font-size: 12px;
  display: flex;
  width: 100%;

  > .left-menu, > .right-container {
    padding: 5px;
    border-radius: 5px;
    background-color: white;
  }

  > .right-container {
    width: 100%;
    margin-left: 5px;
    overflow: hidden;
  }
}

.popup-content {
  width: 100%;
  display: flex;

  > .popup-details {
    width: 50%;

    > .image-container {
      height: 150px;
      width: 150px;
      border: 1px solid gray;
      position: relative;

      > input {
        position: absolute;
        height: 100%;
        width: 100%;
        cursor: pointer;
        opacity: 0;
        z-index: 5;
        top: 0;
        left: 0;

        &:disabled { cursor: default; }
      }

      > .input-text {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        padding: 10px;
      }

      > .hovering {
        background-color: white;
        border: 5px dashed lightblue;
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
        padding: 10px;
      }

      > .image {
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
        position: absolute;
        z-index: 10;

        > img {
          height: 100%;
          width: 100%;
          top: 0;
          left: 0;
          position: absolute;
          z-index: 2;
          object-fit: contain;
        }

        > .close {
          cursor: pointer;
          position: absolute;
          top: 5px;
          right: 5px;
          color: red;
          font-size: 14px;
          z-index: 3;
        }
      }
    }
  }

  > :first-child {
    margin-right: 5px;
  }
}
</style>